import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AmazonButtonProps {
  href: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outline';
  className?: string;
  children?: React.ReactNode;
}

export function AmazonButton({ 
  href, 
  size = 'md', 
  variant = 'default',
  className,
  children 
}: AmazonButtonProps) {
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base'
  };

  const variantClasses = {
    default: 'bg-gradient-to-r from-amazon to-amber-500 text-amazon-foreground hover:from-amber-500 hover:to-amazon shadow-amazon',
    outline: 'border-2 border-amazon text-amazon hover:bg-amazon hover:text-amazon-foreground'
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-200 hover:scale-105',
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
    >
      {children || (
        <>
          <span>Ver en Amazon</span>
          <ExternalLink className="h-4 w-4" />
        </>
      )}
    </a>
  );
}